import { EmitterEvents } from '@/interfaces/event';
import mitt, { Emitter } from 'mitt';

// 使用单例模式
class EventBus {
  private static instance: Emitter<EmitterEvents> | null = null;

  private constructor() {}

  public static getInstance(): Emitter<EmitterEvents> {
    if (!EventBus.instance) {
      EventBus.instance = mitt<EmitterEvents>();
    }
    return EventBus.instance;
  }
}

export default EventBus.getInstance();
